import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setFieldInformation } from "../actions/checkoutStore";

const AddressSearchInput = ({
  onSearch,
  information,
  colors,
  callUpdateRegion,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  // this useEffects are for waiting 2 seconds after user stops writing
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 2000);

    return () => clearTimeout(handler);
  }, [inputValue]);

  useEffect(() => {
    if (!debouncedValue.trim()) return;
    onSearch(debouncedValue);
  }, [debouncedValue]);

  const defaultColor = "#929292";

  const customStyles = (isError) => ({
    control: (base) => ({
      ...base,
      borderRadius: "6px",
      height: "44px",
      padding: "0 8px",
      fontSize: "14px",
      border: isError ? "2px solid #ed2c2c !important;" : "",
      backgroundColor: isError ? "#feeded !important" : "white",
    }),
    placeholder: (base) => ({
      ...base,
      color: defaultColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: defaultColor,
      padding: "8px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({
      ...base,
      padding: "4px 8px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? defaultColor
        : state.isFocused
          ? "#f0f0f0"
          : "#fff",
      color: state.isSelected ? colors.text_color : "#000",
      padding: "8px 12px",
      cursor: "pointer",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  });

  const changeStoreField = (field, value) => {
    dispatch(setFieldInformation(field, value));
  };

  return (
    <div className="row">
      <div className="col-sm-6 pe-sm-1 mb-3">
        {information.regions.length == 0 ? null : (
          <div className="col-12 mb-3">
            <div className={`floating-label-wrap`}>
              <label htmlFor="region" className="label-checkout">
                {t("information.region")}
              </label>
              <div>
                <Select
                  styles={customStyles(information.errors.region)}
                  classNamePrefix="custom-select"
                  placeholder={t("information.select")}
                  searchable
                  id="region"
                  options={information.regions}
                  onChange={(row) => callUpdateRegion(row.value)}
                  value={
                    information.regions.find(
                      (current) => current.value === information.region,
                    ) || ""
                  }
                  autoComplete="address-level1"
                  menuPortalTarget={document.body}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="col-sm-6 pe-sm-1 mb-3">
        {information.municipalities.length > 0 &&
          information.country !== "PT" && (
            <div className="col-12 mb-3">
              <div className={`floating-label-wrap`}>
                <label htmlFor="municipality" className="label-checkout">
                  {t("information.municipality")}
                </label>
                <div>
                  <Select
                    styles={customStyles(information.errors.municipality)}
                    classNamePrefix="custom-select"
                    placeholder={t("information.select")}
                    searchable
                    id="municipality"
                    options={information.municipalities}
                    onChange={(row) =>
                      changeStoreField("municipality", row.value)
                    }
                    value={
                      information.municipalities.find(
                        (current) => current.value === information.municipality,
                      ) || ""
                    }
                    autoComplete="address-level3"
                    menuPortalTarget={document.body}
                  />
                </div>
              </div>
            </div>
          )}
      </div>
      {/* commenting street name address input for now
      <div className="col-12">
        <label
          style={{
            color: colors.text_color,
            marginBottom: "10px",
          }}
          htmlFor="address_for_branch_search"
        >
          {t("information.address_for_branch_search")}
        </label>
        <input
          type="text"
          className="floating-label-field floating-label-field--s1"
          style={{
            padding: "0 0.5em",
          }}
          id="address_for_branch_search"
          placeholder={t("information.address_for_branch_search")}
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
        />
        </div>*/}
    </div>
  );
};

export default AddressSearchInput;
